import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Default, EditorDefinition, Expose, IsMatching, IsSafePassword, Model, ModelId } from '@core/shared/model';
let UpdatePasswordResponse = /*#__PURE__*/(() => {
  let UpdatePasswordResponse = class UpdatePasswordResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], UpdatePasswordResponse.prototype, "success", void 0);
  UpdatePasswordResponse = __decorate([ModelId("UpdatePasswordResponse") // auto-generated by generate-model-ids
  ], UpdatePasswordResponse);
  return UpdatePasswordResponse;
})();
export { UpdatePasswordResponse };
let UpdatePasswordRequest = /*#__PURE__*/(() => {
  let UpdatePasswordRequest = class UpdatePasswordRequest extends Model {
    static {
      this.Response = UpdatePasswordResponse;
    }
  };
  __decorate([IsSafePassword(), Expose()
  // @Default('')
  , __metadata("design:type", String)], UpdatePasswordRequest.prototype, "password", void 0);
  __decorate([IsMatching('password', {
    message: 'Beide Passwörter müssen identisch sein!'
  }), Expose()
  // @Default('')
  , __metadata("design:type", String)], UpdatePasswordRequest.prototype, "password2", void 0);
  __decorate([Expose(), Default(false), __metadata("design:type", Boolean)], UpdatePasswordRequest.prototype, "forcedUpdate", void 0);
  UpdatePasswordRequest = __decorate([AppRequest('auth/credentials', 'password-reset/complete', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId', 'sessionId']
  }), EditorDefinition({
    password: true,
    password2: true,
    forcedUpdate: 'readonly'
  }, {
    useAppRequest: true
  }), ModelId("UpdatePasswordRequest") // auto-generated by generate-model-ids
  ], UpdatePasswordRequest);
  return UpdatePasswordRequest;
})();
export { UpdatePasswordRequest };